export default __webpack_public_path__ + "static/media/slide8.2a9d0a61.jpg";